import { useState } from 'react';
import { Play } from 'lucide-react';
import PosterImage from "@/assets/images/breadcrumbs/3CX-1.webp";
import { useNavigate } from "react-router-dom";

export default function ThreeCXHero() {
    const [isVideoPlaying, setIsVideoPlaying] = useState(false);
    
    const handlePlayVideo = () => {
        setIsVideoPlaying(true);
    };
    const navigate = useNavigate();

    return (
        <div className="py-16">
            <div className="container">
                {/* Header */}
                <div className="text-center mb-12">
                    <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-6 leading-tight">
                        Elevate Your Business Communication with VoIP service
                    </h2>
                    <p className="md:text-lg text-textColor max-w-3xl mx-auto leading-relaxed">
                        Reliable, scalable, and secure VoIP for calls, video, chat, and team collaboration—perfect for businesses of any size.
                    </p>
                </div>

                {/* Video Player Section */}
                <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                    <div className="aspect-video relative bg-black">
                        {/* YouTube Embed */}
                        {isVideoPlaying ? (
                            <iframe
                                className="w-full h-full"
                                src="https://www.youtube.com/embed/4LSOnlSpiO0?autoplay=1"
                                title="VoIP service Video"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            ></iframe>
                        ) : (
                            <>
                                {/* Thumbnail */}
                                <img 
                                    src={PosterImage} 
                                    alt="Video thumbnail" 
                                    className="w-full h-full object-cover"
                                />
                                
                                {/* Play Button Overlay */}
                                <div 
                                    className="absolute inset-0 bg-black/40 flex items-center justify-center cursor-pointer" 
                                    onClick={handlePlayVideo}
                                >
                                    <button
                                        className="group relative"
                                        aria-label="Play video"
                                    >
                                        <div className="absolute inset-0 bg-blue-500 rounded-full blur-xl opacity-50 group-hover:opacity-75 transition-opacity"></div>
                                        <div className="relative bg-blue-600 hover:bg-blue-500 text-white rounded-full p-4 md:p-6 transition-all transform group-hover:scale-110 shadow-2xl">
                                            <Play className="w-6 h-6 md:w-12 md:h-12" fill="currentColor" />
                                        </div>
                                    </button>
                                </div>
                            </>
                        )}
                    </div>
                </div>

                <div className='mt-12 text-center'>
                    <button
                        onClick={() => navigate("/request-for-services")}
                        className="px-10 py-3 bg-gradient-to-r from-purple-600 to-blue-600 text-white font-semibold rounded-lg hover:shadow-xl hover:shadow-purple-500/50 transition-all hover:scale-105 text-center"
                    >
                        Get a Quote
                    </button>
                </div>
            </div>
        </div>
    );
}